var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6909 6.94394C12.7546 7.07352 12.7967 7.21229 12.8155 7.35495L13.1635 12.5298L13.3363 15.1309C13.3381 15.3983 13.38 15.6641 13.4608 15.9196C13.6695 16.4152 14.1715 16.7302 14.7176 16.7083L23.0392 16.164C23.3995 16.158 23.7475 16.2928 24.0065 16.5386C24.2224 16.7435 24.3618 17.0115 24.4057 17.2997L24.4204 17.4748C24.0761 22.2431 20.5739 26.2203 15.8154 27.247C11.0569 28.2737 6.17733 26.1049 3.82589 21.9181C3.14798 20.7018 2.72456 19.3648 2.58048 17.9857C2.52029 17.5775 2.49378 17.1651 2.50122 16.7527C2.49379 11.6404 6.13434 7.22072 11.2304 6.15523C11.8438 6.05973 12.445 6.38443 12.6909 6.94394Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.0867 2.50102C21.7866 2.64603 26.5771 6.74474 27.4992 12.2654L27.4904 12.3061L27.4653 12.3653L27.4688 12.528C27.4557 12.7434 27.3725 12.9507 27.2292 13.1181C27.0799 13.2925 26.8759 13.4113 26.6512 13.4574L26.5142 13.4762L16.9132 14.0983C16.5939 14.1298 16.2759 14.0268 16.0384 13.8149C15.8405 13.6384 15.714 13.4001 15.6782 13.1433L15.0338 3.55633C15.0226 3.52391 15.0226 3.48877 15.0338 3.45635C15.0426 3.19209 15.1589 2.9423 15.3568 2.76279C15.5546 2.58327 15.8175 2.489 16.0867 2.50102Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4116fd16bb40a5d1916c371ab1f36a9f.svg";
export { ForwardRef as ReactComponent };